import { render, staticRenderFns } from "./OpsdForm.vue?vue&type=template&id=f4b97eec&scoped=true"
import script from "./OpsdForm.vue?vue&type=script&lang=js"
export * from "./OpsdForm.vue?vue&type=script&lang=js"
import style0 from "./OpsdForm.vue?vue&type=style&index=0&id=f4b97eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b97eec",
  null
  
)

export default component.exports